import { useSelector } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem, ProductionBatchStatistics } from '@interfaces/search';
import { selectSingleBatchData } from '@reducers/batch';
import { selectNcFileData } from '@reducers/details';
import { selectIsWithERP } from '@reducers/membership';
import { selectUpdatedMachineEventsTimelineHash } from '@reducers/machines';

export const useBatchTimelineSelectors = () => {
  const batch: ReducerEntityWithLoadingState<ProductionBatchStatistics> = useSelector(selectSingleBatchData);
  const ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem> = useSelector(selectNcFileData);
  const isWithERP: boolean | null = useSelector(selectIsWithERP);
  const updatedMachineEventsTimelineHash: string | null = useSelector(selectUpdatedMachineEventsTimelineHash);

  return {
    batch,
    ncFileData,
    isWithERP,
    updatedMachineEventsTimelineHash,
  };
};
